"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 业务系统配置模块
var _default = exports.default = {
  getBusinessList: function getBusinessList(data, cancelToken) {
    return (0, _request.default)({
      url: '/protected/business/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getBusinessDetail: function getBusinessDetail(id) {
    return (0, _request.default)({
      url: '/protected/business/query/' + id,
      method: 'get'
    });
  },
  saveBusiness: function saveBusiness(data) {
    return (0, _request.default)({
      url: '/protected/business/save',
      method: 'post',
      data: data
    });
  },
  deleteBusiness: function deleteBusiness(data) {
    return (0, _request.default)({
      url: '/protected/business/delete',
      method: 'post',
      data: data
    });
  }
};